import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { Loader, Icon } from 'oxyrion-ui/lib';
import { connect, actions } from '../../../../Store';
import Gallery from '../../../ProductCatalog/Components/Gallery';
import AlertPopup from '../../../../Components/AlertPopup';
import { __, getIdFromProps, formatPrice } from '../../../../Utils';
import { LoaderWrapper } from '../../../../Components/ReusableComponents';
import ErrorMessage from '../../../../Components/ErrorMessage';
import AddToCartWidget from '../../../../Components/AddToCartWidget';
import { marketingTranslate } from '../../../ProductCatalog/CatalogUtils';
import API2 from '../../../../API2';

const MainWrapper = styled.div`
  padding: ${rem(50)};
  padding-bottom: ${rem(10)};
  display: flex;
`;

const GalleryWrapper = styled.div`
  margin-right: ${rem(30)};
`;

const BaseInfoWrapper = styled.div`
  width: 100%;
`;

const Title = styled.div`
  font-size: ${rem(26)};
  font-weight: 700;
  color: #434245;
  margin-bottom: ${rem(10)};
`;

const ShortDesc = styled.div`
  font-size: ${rem(14)};
  font-weight: 200;
  color: #434245;
  margin-bottom: ${rem(10)};
`;

const Desc = styled.div`
  font-size: ${rem(16)};
  margin-bottom: ${rem(40)};
  color: #434245;
  text-align: justify;
`;

const Line = styled.div`
  height: ${rem(1)};
  width: 100%;
  margin-bottom: ${rem(15)};
  background: #434245;
`;

const InfoWrapper = styled.div``;

const Label = styled.div`
  color: #434245;
  margin-right: 16px;
  font-weight: bold;
  width: ${rem(170)};
`;

const Value = styled.div``;

const Row = styled.div`
  display: flex;
  align-items: center;
  font-size: ${rem(14)};
  margin-bottom: ${rem(8)};
`;

const AddToCardWrapper = styled.div`
  height: ${rem(32)};
  padding: 0px 8px;
  margin-top: ${rem(16)};
  color: #70af00;
  border: 1px solid #70af00;
  border-radius: ${rem(2)};
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  cursor: pointer;
  &:hover {
    box-shadow: 0 0 ${rem(8)} ${rem(0)} #70af00;
  }
`;

const AddTitle = styled.div`
  margin-right: ${rem(12)};
`;

class MarketingMaterialDetail extends React.Component {
  state = {
    selectedImage: 'main',
    selectedColorCode: '',
    showColorCards: false,
    productLoading: true,
    addToCart: false,
    material: {},
  };

  async componentDidMount() {
    const id = getIdFromProps(this.props);
    await this.fetchMarketingMaterial(id);

    actions.setActiveMenuItem('81');
  }

  async fetchMarketingMaterial(id) {
    try {
      const material = await API2.getB2BMarketingMaterialAction(id);
      this.setState({
        material,
        productLoading: false,
      });
    } catch (e) {
      console.log(e);
    }
  }

  render() {
    const {
      material,
      selectedImage,
      productLoading,
      error,
      showProductAddedPopup,
      showComplementaryAdded,
      addToCart,
    } = this.state;

    if (productLoading) {
      return (
        <LoaderWrapper>
          <Loader size="xl" color="#70af00" />
        </LoaderWrapper>
      );
    }

    return (
      <React.Fragment>
        <div style={{ padding: rem(20) }}>
          <ErrorMessage display={error} text={error} />
          <ErrorMessage
            display={showProductAddedPopup}
            success
            timeToShow={4}
            text={__('Produkt bol pridaný do objednávky')}
          />
        </div>
        <AddToCartWidget
          history={this.props.history}
          callback={() => {
            this.setState({
              addToCart: false,
              showProductAddedPopup: true,
            });
          }}
          closeCallBack={() =>
            this.setState({
              addToCart: false,
            })
          }
          product={addToCart ? material.product : null}
        />

        <MainWrapper>
          <AlertPopup
            alignUnderHeader
            display={showComplementaryAdded}
            text={__('Produkt bol pridaný do objednávky')}
            success
            onClose={() =>
              this.setState({
                showComplementaryAdded: false,
              })
            }
            onSubmit={() =>
              this.setState({
                showComplementaryAdded: false,
              })
            }
          />

          <GalleryWrapper>
            <Gallery
              images={
                material.image
                  ? [{ path: material.image.fullPath, name: 'main' }]
                  : []
              }
              selectedImage={selectedImage}
              onImageSelect={() => {}}
              showMorePhotos={false}
            />
          </GalleryWrapper>
          <BaseInfoWrapper>
            <Title>{material.name}</Title>
            <ShortDesc>
              {marketingTranslate(
                this.props.appLang,
                material.short_description_translations,
                material.short_description,
              )}
            </ShortDesc>
            <Line />
            <Desc>
              {' '}
              {marketingTranslate(
                this.props.appLang,
                material.long_description_translations,
                material.long_description,
              )}
            </Desc>
            <InfoWrapper>
              <Row>
                <Label>{__('Názov produktu:')}</Label>
                <Value>
                  {material.product ? material.product.Description : ' - '}
                </Value>
              </Row>

              <Row>
                <Label>{__('Ean:')}</Label>
                <Value>{material.product ? material.product.Ean : '-'}</Value>
              </Row>

              <Row>
                <Label>{__('Nákupná cena bez DPH:')}</Label>
                <Value>
                  {material.product
                    ? formatPrice(material.product.Unit_Price)
                    : '-'}
                </Value>
              </Row>
              <Row>
                <Label>{__('Nákupná cena s DPH:')}</Label>
                <Value>
                  {material.product
                    ? formatPrice(material.product.Unit_Price_VAT)
                    : '-'}
                </Value>
              </Row>
              <Row>
                <Label />
                {material.product && (
                  <AddToCardWrapper
                    onClick={() =>
                      this.setState({
                        addToCart: true,
                      })
                    }
                  >
                    <AddTitle>{__('Pridať do košíka')}</AddTitle>
                    <Icon name="cart_add" color="#70af00" />
                  </AddToCardWrapper>
                )}
              </Row>
            </InfoWrapper>
          </BaseInfoWrapper>
        </MainWrapper>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(MarketingMaterialDetail);



// WEBPACK FOOTER //
// ./src/Containers/Marketing/MarketingMaterials/Detail/index.jsx